<div class="checkbox" [class.disabled]="disabled">
  <input type="checkbox" class="checkbox__field" [id]="checkboxId" [name]="name" [checked]="value" [disabled]="disabled" (change)="toggle(); onChange(value)" #checkboxInput />
  <label class="checkbox__label" [for]="checkboxId" [ngStyle]="{ cursor: cursor }">
    <ng-content></ng-content>
  </label>
</div>
